"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INEGI_TO_SAT_CODE_MAP = exports.MEXICAN_STATES_ARRAY = exports.MEXICAN_STATES = void 0;
exports.toSATStateCode = toSATStateCode;
/**
 * Mexican States - SAT Federal Entity Codes (c_Estado)
 *
 * Using SAT codes instead of INEGI codes for CFDI compatibility.
 * These codes are required for electronic invoicing (CFDI) in Mexico.
 *
 * @see SAT Catalog: http://omawww.sat.gob.mx/tramitesyservicios/Paginas/anexo_20_version3-3.htm
 */
exports.MEXICAN_STATES = {
    AGU: 'Aguascalientes',
    BCN: 'Baja California',
    BCS: 'Baja California Sur',
    CAM: 'Campeche',
    CHP: 'Chiapas',
    CHH: 'Chihuahua',
    COA: 'Coahuila de Zaragoza',
    COL: 'Colima',
    DIF: 'Ciudad de México', // Distrito Federal in SAT codes
    DUR: 'Durango',
    GUA: 'Guanajuato',
    GRO: 'Guerrero',
    HID: 'Hidalgo',
    JAL: 'Jalisco',
    MEX: 'Estado de México',
    MIC: 'Michoacán de Ocampo',
    MOR: 'Morelos',
    NAY: 'Nayarit',
    NLE: 'Nuevo León',
    OAX: 'Oaxaca',
    PUE: 'Puebla',
    QUE: 'Querétaro',
    ROO: 'Quintana Roo',
    SLP: 'San Luis Potosí',
    SIN: 'Sinaloa',
    SON: 'Sonora',
    TAB: 'Tabasco',
    TAM: 'Tamaulipas',
    TLA: 'Tlaxcala',
    VER: 'Veracruz de Ignacio de la Llave',
    YUC: 'Yucatán',
    ZAC: 'Zacatecas',
};
/**
 * Helper array for frontend dropdowns
 * Sorted alphabetically by state name for better UX
 */
exports.MEXICAN_STATES_ARRAY = Object.entries(exports.MEXICAN_STATES)
    .map(([code, name]) => ({
    code: code,
    name,
}))
    .sort((a, b) => a.name.localeCompare(b.name, 'es'));
/**
 * Migration helper: INEGI to SAT code mapping
 * Use this for database migrations from old INEGI codes to SAT codes
 */
exports.INEGI_TO_SAT_CODE_MAP = {
    AGS: 'AGU',
    BC: 'BCN',
    BCS: 'BCS',
    CAMP: 'CAM',
    CHIS: 'CHP',
    CHIH: 'CHH',
    COAH: 'COA',
    COL: 'COL',
    CDMX: 'DIF',
    DGO: 'DUR',
    GTO: 'GUA',
    GRO: 'GRO',
    HGO: 'HID',
    JAL: 'JAL',
    MEX: 'MEX',
    MICH: 'MIC',
    MOR: 'MOR',
    NAY: 'NAY',
    NL: 'NLE',
    OAX: 'OAX',
    PUE: 'PUE',
    QRO: 'QUE',
    QROO: 'ROO',
    SLP: 'SLP',
    SIN: 'SIN',
    SON: 'SON',
    TAB: 'TAB',
    TAMPS: 'TAM',
    TLAX: 'TLA',
    VER: 'VER',
    YUC: 'YUC',
    ZAC: 'ZAC',
};
/**
 * Convert INEGI code to SAT code
 * Returns the code unchanged if already a valid SAT code
 */
function toSATStateCode(code) {
    const upperCode = code.toUpperCase();
    // Check if already a valid SAT code
    if (upperCode in exports.MEXICAN_STATES) {
        return upperCode;
    }
    // Try to convert from INEGI
    return exports.INEGI_TO_SAT_CODE_MAP[upperCode] || null;
}
